var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGeolocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5291 19.081C16.4263 19.081 14.8232 17.3784 14.8232 15.3751C14.8232 13.2723 16.5258 11.6692 18.5291 11.6692C20.6318 11.6692 22.2349 13.3718 22.2349 15.3751C22.2349 17.3784 20.5312 19.081 18.5291 19.081M18.4818 7.43394C14.1059 7.43394 10.5879 10.9914 10.5879 15.4137C10.5879 19.3553 16.7706 26.0849 18.0063 27.3351C18.2907 27.6238 18.7674 27.6238 19.0519 27.3351C20.2875 25.9894 26.4702 19.2587 26.4702 15.4137C26.3758 11.0868 22.8566 7.43394 18.4818 7.43394",
    fill: "#F03B38"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 35
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0224609H36V34.9636H0V0.0224609Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11718 16.4689C3.11718 19.6246 3.41632 21.498 4.01461 22.089C6.88153 26.5667 8.84286 29.3412 9.89511 30.4114C12.3558 31.9467 15.2483 32.7137 18.5715 32.7137H18.9603C23.6291 32.7137 27.5424 29.9276 30.7015 24.3529C32.1565 20.6703 32.8828 17.9308 32.8828 16.1367C32.8828 14.6713 32.4975 12.8038 31.7281 10.5317C30.9262 7.71411 29.6493 5.63674 27.8963 4.30661C25.46 2.43441 22.7375 1.49831 19.7274 1.49831C14.9492 1.49831 10.3083 3.75754 5.806 8.27601C4.01461 10.6367 3.11718 13.1955 3.11718 15.949V16.4689ZM0 13.9462C0 11.0668 0.930031 8.94865 2.78893 7.59171C7.52755 2.54516 12.6177 0.0224609 18.057 0.0224609H19.2816C24.1238 0.0224609 28.2117 1.5053 31.5454 4.46982C32.7315 5.90719 33.658 7.50195 34.3238 9.25524C35.4413 12.1102 36 14.4813 36 16.3722C36 18.7713 34.9606 22.2791 32.8817 26.8989C30.1591 30.7984 27.4086 33.2267 24.6313 34.1768C23.2671 34.7013 21.6305 34.9636 19.7239 34.9636H19.1675C15.8827 34.9636 12.5013 34.101 9.02328 32.3815C6.91878 31.3976 5.09946 29.1908 3.57113 25.753C1.34208 22.8479 0.226979 20.7881 0.226979 19.5722V18.6839C0.226979 17.9984 0.151319 16.4188 0 13.9462V13.9462Z",
    fill: "#F03B38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeolocation);
export default __webpack_public_path__ + "static/media/icon_geolocation.39e859776200d128e4af8de3fbc215e5.svg";
export { ForwardRef as ReactComponent };